import { render, staticRenderFns } from "./toggleDescV2.vue?vue&type=template&id=2637ccee&scoped=true"
import script from "./toggleDescV2.vue?vue&type=script&lang=js"
export * from "./toggleDescV2.vue?vue&type=script&lang=js"
import style0 from "./toggleDescV2.vue?vue&type=style&index=0&id=2637ccee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2637ccee",
  null
  
)

export default component.exports